// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__CuMPd","widget":"Login_widget__2Eg-N"};